import { CommonModule } from '@angular/common';
import { Component, forwardRef, input, signal } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'abb-switch',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <label
      class="flex items-center h-5 group"
      [ngClass]="{
        'flex-row-reverse': switchPosition() === 'right',
        'cursor-pointer': !disabled
      }"
    >
      <input
        [id]="id()"
        class="peer appearance-none h-0 w-0 min-h-0 min-w-0 block"
        type="checkbox"
        (blur)="onTouched()"
        [(ngModel)]="value"
        [required]="required()"
        [disabled]="disabled"
        (change)="handleOnChange($event)"
        [name]="name()"
      />
      <div
        [ngClass]="{
          'h-3.5 w-9': size() === 'normal',
          'h-2 w-8': size() === 'small'
        }"
        class="overflow-visible transition-all flex-shrink-0 rounded-lg flex items-center justify-start peer-checked:justify-end peer-checked:peer-disabled:bg-abb-gray-04 peer-checked:bg-abb-primary-light peer-disabled:bg-abb-gray-04 bg-abb-gray-03"
      >
        <div
          class="rounded-full transition-all  group-focus-within:outline group-focus-within:outline-4"
          [ngClass]="{
            'bg-abb-primary group-focus-within:outline-abb-primary-light/40':
              value && !disabled,
            'bg-abb-gray-03': disabled && value,
            'bg-abb-gray-04': !disabled && !value,
            'bg-abb-gray-05': disabled && !value,
            'group-focus-within:outline-abb-gray-04/40': !value && !disabled,
            shadow: !disabled,
            'h-5 w-5': size() === 'normal',
            'h-4 w-4': size() === 'small'
          }"
        ></div>
      </div>
      @if (label()) {
      <span
        [ngClass]="{
          'ml-3': switchPosition() === 'left',
          'mr-3': switchPosition() === 'right',
          'text-sm': labelSize() === 'small',
          'text-base': labelSize() === 'normal'
        }"
        class="peer-disabled:text-abb-gray-03"
        >{{ label() }}</span
      >
      }</label
    >
  `,
  styles: ``,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AbbSwitchComponent),
      multi: true,
    },
  ],
})
export class AbbSwitchComponent implements ControlValueAccessor {
  switchPosition = input<'left' | 'right'>('left');
  label = input('');
  id = input<string>('')
  labelSize = input<'small' | 'normal'>('small');
  name = input('');
  size = input<'small' | 'normal'>('normal');
  value = false;
  disabled = false;
  required = signal(false);
  onChange = (_v: boolean) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = () => {
      fn();
    };
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  handleOnChange(e: Event) {
    this.onChange(
      Boolean((e.target as EventTarget & { checked: boolean })?.checked)
    );
  }
}
